import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { AutomationsHeaderTiles, AutomationsTable } from '../../containers'
import { automationOperations } from '../../../../state/ducks/automations'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { AutomationShape, PaginationShape } from '../../../../prop-types'

class AutomationsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchAutomations = this.fetchAutomations.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchAutomations()
  }

  fetchAutomations () {
    this.props.fetchAutomations(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchAutomations())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Automations</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Automations'} subTitle={'All automations'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <AutomationsHeaderTiles all_automations={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchAutomations}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All automations</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <AutomationsTable automations={this.props.automations} params={this.state.params}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </AutomationsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
AutomationsPage.propTypes = {
  automations: arrayOf(AutomationShape).isRequired,
  fetchAutomations: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
AutomationsPage.defaultProps = {
  automations: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.automations.fetchAutomationsReducer.loading,
  automations: state.automations.fetchAutomationsReducer.data.results,
  paginationData: state.automations.fetchAutomationsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchAutomations: automationOperations.list
}

// Export Class
const _AutomationsPage = connect(mapStateToProps, mapDispatchToProps)(AutomationsPage)
export { _AutomationsPage as AutomationsPage }
